export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-wireframes-ee46bbc3ee05293eeb692a4df595aa1c.png";